import { isPlatformBrowser } from '@angular/common';
import { Component, Directive, Inject, Input, PLATFORM_ID } from '@angular/core';
import { ApiProductIdEnum } from 'outshared-lib';
import { SessionStorageService } from '@inshared/shared/util-storage';

@Directive({
    selector: 'hero-title-icon,hero-header-icon',
})
export class HeroTitleIconDirective {}

@Directive({
    selector: 'hero-title-title,hero-header-title',
})
export class HeroTitleTitleDirective {}

@Directive({
    selector: 'hero-title-aggregate,hero-header-aggregate',
})
export class HeroTitleAggregateDirective {}

@Directive({
    selector: 'hero-header-content',
})
export class HeroHeaderContentDirective {}

@Component({
    selector: 'ins-hero-header',
    templateUrl: 'hero-header.component.html',
    styleUrls: ['hero-header.component.scss'],
})
export class HeroHeaderComponent {
    @Input() productId: ApiProductIdEnum;
    @Input() suffix: string;
    @Input() icon: string;
    public collectivity: boolean = false;

    public carImage = {
        src: '/assets/shared/banners/shmuppet-car-banner-1920w.webp',
        srcset: {
            300: '/assets/shared/banners/shmuppet-car-banner-300w.webp',
            600: '/assets/shared/banners/shmuppet-car-banner-600w.webp',
            900: '/assets/shared/banners/shmuppet-car-banner-900w.webp',
            1920: '/assets/shared/banners/shmuppet-car-banner-1920w.webp',
        },
    };

    constructor(
        @Inject(PLATFORM_ID) platformId: object,
        @Inject(SessionStorageService) private sessionStorage: Storage
    ) {
        if (isPlatformBrowser(platformId)) {
            this.getCollectivity();
        }
    }

    getSrcSet(srcset: { [key: string]: string }): string {
        return Object.keys(srcset)
            .map((key) => key + 'w')
            .join(', ');
    }

    private getCollectivity(): void {
        this.collectivity = !!this.sessionStorage.getItem('collectiviteit');
    }
}
